import { css } from '@emotion/react';

/**
 * Shared styling for the colored round/stage chip used on deal round cards
 * (the activity-drawer sidebar and the company-profile Deals tab). Pair the
 * background/color with `getRoundColor`. `opts` covers the small size differences
 * between the two surfaces (the sidebar chip is slightly smaller).
 */
export const roundChipCss = (
  background: string,
  color: string,
  opts: { fontSize?: string; labelPadding?: string } = {}
) => css`
  border: 0.5px solid white;
  border-radius: 4px;
  height: auto;
  font-weight: 400;
  letter-spacing: 0.17px;
  font-size: ${opts.fontSize ?? '14px'};
  background-color: ${background};
  color: ${color};

  .MuiChip-label {
    padding: ${opts.labelPadding ?? '2px 10px'};
    line-height: 1.43;
  }
`;
